// src/components/Landing/Hero.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from 'components/Elements';
import BGImage from 'assets/bg.png';

export const Hero = ({ onStart, title, subtitle, cta }) => {
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.12 } },
  };
  const fadeUp = { hidden: { opacity: 0, y: 12 }, show: { opacity: 1, y: 0 } };

  return (
    <section className="relative flex items-center justify-center h-screen overflow-hidden">
      <img
        src={BGImage}
        alt=""
        aria-hidden
        className="absolute inset-0 w-full h-full object-cover transform scale-105 brightness-75"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-transparent" />
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="relative z-20 max-w-4xl mx-6 md:mx-0 bg-white/6 rounded-2xl p-8 md:p-12 backdrop-blur-sm border border-white/6"
      >
        <motion.div variants={fadeUp} className="flex justify-center mb-6">
          <div className="rounded-full p-2 bg-white/10">
            <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-gradient-to-br from-amber-400 to-rose-500 text-slate-900 font-bold">
              A
            </div>
          </div>
        </motion.div>

        <motion.h1
          variants={fadeUp}
          className="text-3xl md:text-5xl font-extrabold text-center leading-tight"
        >
          {title}
        </motion.h1>

        <motion.p variants={fadeUp} className="mt-4 text-center text-slate-200 max-w-2xl mx-auto">
          {subtitle}
        </motion.p>

        <motion.div
          variants={fadeUp}
          className="mt-8 flex flex-col md:flex-row md:justify-center gap-4"
        >
          <Button variant="solid" size="lg" onClick={onStart}>
            {cta}
          </Button>
          <Button
            variant="ghost"
            size="md"
            onClick={() => window.open('https://ayinzahome.com', '_blank')}
          >
            Visit website
          </Button>
        </motion.div>

        <motion.div
          variants={fadeUp}
          className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 text-sm text-slate-300"
          aria-hidden
        >
          <div className="flex flex-col items-center">
            <strong className="text-amber-300">Tailored</strong>
            <span className="opacity-70 text-xs">Custom workflows</span>
          </div>
          <div className="flex flex-col items-center">
            <strong className="text-amber-300">Secure</strong>
            <span className="opacity-70 text-xs">Role-based access</span>
          </div>
          <div className="hidden sm:flex flex-col items-center">
            <strong className="text-amber-300">Integrations</strong>
            <span className="opacity-70 text-xs">Odoo, Payments</span>
          </div>
        </motion.div>
      </motion.div>

      {/* Decorative animated element */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 40 }}
        animate={{ opacity: 0.15, scale: 1.1, y: 0 }}
        transition={{ repeat: Infinity, repeatType: 'reverse', duration: 6, ease: 'easeInOut' }}
        className="pointer-events-none absolute right-10 bottom-8 w-48 h-48 rounded-2xl bg-gradient-to-br from-rose-500 to-amber-400 blur-3xl"
        aria-hidden
      />
    </section>
  );
};
